export const authErrorNames = {
    USER_NOT_FOUND: "UserNotFoundException",
    CODE_MISMATCH: "CodeMismatchException",
    LIMIT_EXCEEDED: "LimitExceededException",
};

export const localStorageSelectOrgUuid = "selectOrganizationUuid";
